export default __webpack_public_path__ + "static/media/blog-2.0e0b276c.jpg";